import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { AppSettings } from './config';
import * as jwt_decode from "jwt-decode";

@Injectable()
export class UtilsService {
    private main: string = "main";
    public AppSettings = new AppSettings;

    constructor(private http: HttpClient) { }   
    
    getUserData(){
        let myUser: any = localStorage.getItem('currentUser');
        myUser = JSON.parse(myUser);  
        let jwt = jwt_decode(myUser.token);
        return jwt;
    }
}


// WEBPACK FOOTER //
// /home/estandar/web/tuhogaronline.tk/public_html/adminTHO/src/app/helpers/utils.service.ts